import { Box } from '@mantine/core';
import { MarketingFooter } from '#marketing/components/MarketingFooter.jsx';
import { SkipLink } from '#marketing/components/SkipLink.jsx';
import { Header } from './Header.jsx';
import classes from './MarketingShell.module.css';

/**
 * Layout shell for apex marketing pages.
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
export function MarketingShell({ children }) {
  return (
    <div className={classes.root}>
      <SkipLink />
      <Header />
      <Box component="main" id="main-content" className={classes.main}>
        {children}
      </Box>
      <MarketingFooter />
    </div>
  );
}
